// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsEnrollmentEnrollPatientEnrollmentInputModel {
    static getAttributeTypeMap() {
        return ScriptsEnrollmentEnrollPatientEnrollmentInputModel.attributeTypeMap;
    }
}
ScriptsEnrollmentEnrollPatientEnrollmentInputModel.discriminator = undefined;
ScriptsEnrollmentEnrollPatientEnrollmentInputModel.attributeTypeMap = [
    {
        "name": "paymentTypeCode",
        "baseName": "paymentTypeCode",
        "type": "string"
    }
];
//# sourceMappingURL=scriptsEnrollmentEnrollPatientEnrollmentInputModel.js.map